<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onUserSelected(null)">
          <i class="fa-solid fa-user-plus"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card  v-model="filter" v-bind:fields="filterFields" search>
      <template #filter(roleId)="{field}">
        <v-select
            class="small"
            v-model="filter[field.key]"
            :options="allRoles"
            label="name"
            :reduce="r=>r.id"
            multiple
        />
      </template>
    </filter-card>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{$t("menu.users")}}</h5>
      </b-card-header>
      <b-card-body>
        <users-table ref="userTable" v-bind:filters="filter" v-bind:columns="columns"
                     :has-selection="hasPermission(permissions.USER_ACTIONS)"
                     @selected="onUserSelected" :lazy="true">
          <template #table-top-actions="{ selectedIds }">
            <div class="uv-bulk" v-if="Object.keys(selectedIds).length">
              <span class="uv-bulk__count">
                <i class="fa-solid fa-check-double mr-25"></i>
                {{ Object.keys(selectedIds).length }} {{ $t('finance.actionModal.selected') }}
              </span>
              <b-button size="sm" variant="warning" @click="openBulkHide">
                <i class="fa-solid fa-eye-slash mr-25"></i>{{ $t('users.hide') }}
              </b-button>
              <b-button size="sm" variant="flat-secondary" @click="$refs.userTable.clearSelection()">
                {{ $t('operations.cancel') }}
              </b-button>
            </div>
          </template>
        </users-table>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="users" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <user-modal ref="user-modal" @refresh="refreshTable" />
    <user-bulk-hide-modal ref="bulkHide" @done="onBulkHideDone"/>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import UserSearchRequest from '@/model/user/UserSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import User from '@/model/user/User'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import UserModal from '@/components/modal/userModal'
import FilterCard from '@/components/widget/FilterCard'
import UserFilterFields from '@/model/filter/UserFilterFields'
import UsersTable from '@/components/tables/UsersTable'
import UserBulkHideModal from '@/components/modal/UserBulkHideModal'

export default {
  name: 'UsersView',
  components: {UsersTable, FilterCard, UserModal, ColumnsModal, BreadcrumbButton, UserBulkHideModal },
  mixins: [mixinBase,mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(User()),
      filter: UserSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = UserFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
    ...mapGetters('users', ['allRoles']),

  },
  methods: {
    ...mapActions('users', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onUserSelected(selectedId) {
      // console.log("onUserSelected", selectedId)
      this.$refs['user-modal'].showModal(selectedId)
    },
    refreshTable() {
      this.$refs['userTable'].refresh()
    },
    openBulkHide() {
      const table = this.$refs.userTable;
      const items = table ? table.getAllSelectedItems() : [];
      if (!items.length) return;
      this.$refs.bulkHide.open(items);
    },
    onBulkHideDone() {
      const table = this.$refs.userTable;
      if (table) {
        table.clearSelection();
        table.refresh();
      }
    },
  }
}
</script>

<style>
/* Bulk-selection bar (mirrors the finance/monetary ones) */
.uv-bulk {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.75rem;
  border-radius: 10px;
  background: rgba(255, 159, 67, 0.1);
  margin-bottom: 0.5rem;
}
.uv-bulk__count {
  font-weight: 700;
  font-size: 0.85rem;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
